import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import React, { memo } from 'react';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const Products = ({ open, setOpen, data }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const dataList = data?.sale?.products;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[55vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>Savdo</span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper'>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='changes-table'>
                <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
                  <Table
                    stickyHeader
                    sx={{ width: 'inherit' }}
                    aria-labelledby='tableTitle'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>№</TableCell>
                        <TableCell>Nomi</TableCell>
                        <TableCell>Soni</TableCell>
                        <TableCell>Narxi</TableCell>
                        <TableCell>Foyda</TableCell>
                      </TableRow>
                    </TableHead>
                    {dataList && dataList?.length > 0 ? (
                      <TableBody className='overflow-hidden'>
                        {dataList.map((row, rowIndex) => (
                          <TableRow hover tabIndex={-1} key={'row-' + rowIndex}>
                            <TableCell>{rowIndex + 1}</TableCell>
                            <TableCell>{row?.name || ''}</TableCell>
                            <TableCell>{row?.amount || ''}</TableCell>
                            <TableCell>
                              <CurrencyFormat
                                value={Number(row?.price) || ''}
                              />
                            </TableCell>
                            <TableCell>
                              <CurrencyFormat
                                value={Number(row?.profit) || ''}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow hover tabIndex={-1} key={'row-last-total'}>
                          <TableCell>#</TableCell>
                          <TableCell>
                            <b>Jami summa:</b>
                          </TableCell>
                          <TableCell />
                          <TableCell>
                            <b>
                              <CurrencyFormat
                                value={
                                  dataList?.reduce(
                                    (a, b) =>
                                      a + Number(b?.amount) * Number(b?.price),
                                    0
                                  ) || ''
                                }
                              />
                            </b>
                          </TableCell>
                          <TableCell>
                            <b>
                              <CurrencyFormat
                                value={
                                  dataList?.reduce(
                                    (a, b) =>
                                      a + Number(b?.amount) * Number(b?.profit),
                                    0
                                  ) || ''
                                }
                              />
                            </b>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody component='div'>
                        <TableRow component='div'>
                          <TableCell colSpan={6}>
                            <span className='text-gray-400 flex items-center justify-center'>
                              <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                              Ma'lumot topilmadi!
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(Products);
